"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _TagNotFound = _interopRequireDefault(require("./errors/TagNotFound"));

var _ConflictError = _interopRequireDefault(require("./errors/ConflictError"));

var _qs = _interopRequireDefault(require("qs"));

var DEFAULT_BASE_URL = 'https://tagliatelle.trdlnk.cimpress.io';

var Tagliatelle = /*#__PURE__*/function () {
  function Tagliatelle(clientOptions) {
    (0, _classCallCheck2["default"])(this, Tagliatelle);
    var understoodOptions = ['baseUrl', 'timeout', 'retryAttempts', 'retryDelayInMs', 'autoFetchPagedResults', 'debugFunction', 'errorFunction', 'skipCache'];
    var options = clientOptions || {};
    var timeout = parseInt(options.timeout, 10);
    var retryAttempts = parseInt(options.retryAttempts, 10);
    var retryDelayInMs = parseInt(options.retryDelayInMs, 10);
    this.baseUrl = options.baseUrl || DEFAULT_BASE_URL;
    this.timeout = timeout >= 0 ? timeout : 3000;
    this.retryAttempts = retryAttempts >= 0 ? retryAttempts : 3;
    this.retryDelayInMs = retryDelayInMs >= 0 ? retryDelayInMs : 1000;
    this.autoFetchPagedResults = options.autoFetchPagedResults || false;
    this.skipCache = typeof options.skipCache === 'boolean' ? options.skipCache : true;
    this.debugFunction = Object.keys(options).includes('debugFunction') ? options.debugFunction : console.info;
    this.errorFunction = Object.keys(options).includes('errorFunction') ? options.errorFunction : console.error;
    Object.keys(options).forEach(function (passedOption) {
      if (understoodOptions.indexOf(passedOption) === -1) {
        // eslint-disable-next-line no-console
        console.error("[Tagliatelle] Option '".concat(passedOption, "' is not understood and will be ignored."));
      }
    });
  }

  (0, _createClass2["default"])(Tagliatelle, [{
    key: "__debug",
    value: function __debug() {
      if (this.debugFunction) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.debugFunction.apply(this, ['[TagliatelleClient]'].concat(args));
      }
    }
  }, {
    key: "__error",
    value: function __error() {
      if (this.errorFunction) {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        this.errorFunction.apply(this, ['[TagliatelleClient]'].concat(args));
      }
    }
  }, {
    key: "__getAxiosInstance",
    value: function __getAxiosInstance(accessToken) {
      var _this = this;

      var instance = _axios["default"].create({
        baseURL: this.baseUrl,
        timeout: this.timeout,
        headers: {
          Authorization: "Bearer ".concat(accessToken.replace('Bearer ', ''))
        }
      });

      if (this.retryAttempts > 0) {
        (0, _axiosRetry["default"])(instance, {
          retries: this.retryAttempts,
          retryDelay: function retryDelay(retryCount) {
            return _this.retryDelayInMs;
          },
          shouldResetTimeout: true
        });
      }

      return instance;
    }
  }, {
    key: "getTags",
    value: function () {
      var _getTags = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(accessToken, searchParams) {
        var results, total, fullResults, retrievedCount, partial;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.__getTagsPartial(accessToken, searchParams);

              case 2:
                results = _context.sent;

                if (!(!this.autoFetchPagedResults || results.total === results.count + (results.offset || 0))) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", results);

              case 5:
                total = results.total;
                fullResults = results;
                retrievedCount = results.count;

              case 8:
                if (!(retrievedCount < total)) {
                  _context.next = 18;
                  break;
                }

                searchParams.offset = retrievedCount;
                _context.next = 12;
                return this.__getTagsPartial(accessToken, searchParams);

              case 12:
                partial = _context.sent;
                retrievedCount += partial.count;
                fullResults.count = retrievedCount;
                fullResults.results = fullResults.results.concat(partial.results);
                _context.next = 8;
                break;

              case 18:
                return _context.abrupt("return", fullResults);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTags(_x, _x2) {
        return _getTags.apply(this, arguments);
      }

      return getTags;
    }()
  }, {
    key: "__getTagsPartial",
    value: function () {
      var _getTagsPartial = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(accessToken, searchParams) {
        var uris, keys, skipCacheParams, params, axiosInstance, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                uris = [];

                if (Array.isArray(searchParams.resourceUri) && searchParams.resourceUri.length > 0) {
                  uris = uris.concat(searchParams.resourceUri);
                } else if (searchParams.resourceUri) {
                  uris.push(searchParams.resourceUri);
                }

                keys = [];

                if (Array.isArray(searchParams.key) && searchParams.key.length > 0) {
                  keys = keys.concat(searchParams.key);
                } else if (searchParams.key) {
                  keys.push(searchParams.key);
                }

                skipCacheParams = {};

                if (this.skipCache) {
                  skipCacheParams.skipCache = Math.random();
                }

                params = Object.assign({}, skipCacheParams, {
                  namespace: searchParams.namespace ? searchParams.namespace : undefined,
                  key: keys.length > 0 ? keys : undefined,
                  resourceUri: uris.length > 0 ? uris : undefined,
                  offset: Number.isInteger(Number(searchParams.offset)) && Number(searchParams.offset) > 0 ? searchParams.offset : undefined
                });
                axiosInstance = this.__getAxiosInstance(accessToken);

                this.__debug("Calling GET ".concat(this.baseUrl, "/v0/tags ..."), params);

                _context2.next = 11;
                return axiosInstance.get("".concat(this.baseUrl, "/v0/tags"), {
                  params: params,
                  paramsSerializer: function paramsSerializer(params) {
                    return _qs["default"].stringify(params, {
                      indices: false
                    });
                  }
                });

              case 11:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function __getTagsPartial(_x3, _x4) {
        return _getTagsPartial.apply(this, arguments);
      }

      return __getTagsPartial;
    }()
  }, {
    key: "getTagsByResource",
    value: function () {
      var _getTagsByResource = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(accessToken, resourceUri) {
        var namespace,
            offset,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                namespace = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : null;
                offset = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
                return _context3.abrupt("return", this.__getTagsPartial(accessToken, {
                  resourceUri: resourceUri,
                  namespace: namespace,
                  offset: offset
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getTagsByResource(_x5, _x6) {
        return _getTagsByResource.apply(this, arguments);
      }

      return getTagsByResource;
    }()
  }, {
    key: "getTagsByResources",
    value: function () {
      var _getTagsByResources = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(accessToken, resourcesUriArray) {
        var namespace,
            offset,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                namespace = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : null;
                offset = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : null;
                return _context4.abrupt("return", this.__getTagsPartial(accessToken, {
                  resourceUri: resourcesUriArray,
                  namespace: namespace,
                  offset: offset
                }));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getTagsByResources(_x7, _x8) {
        return _getTagsByResources.apply(this, arguments);
      }

      return getTagsByResources;
    }()
  }, {
    key: "getTagByResourceAndKey",
    value: function () {
      var _getTagByResourceAndKey = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(accessToken, resourceUri, tagKey) {
        var _this2 = this;

        var offset,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                offset = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : null;
                return _context5.abrupt("return", this.__getTagsPartial(accessToken, {
                  resourceUri: resourceUri,
                  key: tagKey,
                  offset: offset
                }).then(function (res) {
                  var results = res.results;

                  if (results.length === 0) {
                    throw new _TagNotFound["default"]();
                  }

                  return results[0];
                })["catch"](function (e) {
                  _this2.__error(e);

                  throw e;
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getTagByResourceAndKey(_x9, _x10, _x11) {
        return _getTagByResourceAndKey.apply(this, arguments);
      }

      return getTagByResourceAndKey;
    }()
  }, {
    key: "getTagsByKey",
    value: function () {
      var _getTagsByKey = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(accessToken, tagKey) {
        var offset,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                offset = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
                return _context6.abrupt("return", this.__getTagsPartial(accessToken, {
                  key: tagKey,
                  offset: offset
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getTagsByKey(_x12, _x13) {
        return _getTagsByKey.apply(this, arguments);
      }

      return getTagsByKey;
    }()
  }, {
    key: "getTagById",
    value: function () {
      var _getTagById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(accessToken, id) {
        var axiosInstance, response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                axiosInstance = this.__getAxiosInstance(accessToken);
                _context7.prev = 1;

                this.__debug("Calling ".concat(this.baseUrl, "/v0/tags/").concat(encodeURIComponent(id), " ..."));

                _context7.next = 5;
                return axiosInstance.get("".concat(this.baseUrl, "/v0/tags/").concat(encodeURIComponent(id)));

              case 5:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](1);

                this.__error(_context7.t0);

                if (!(_context7.t0.response && _context7.t0.response.status === 404)) {
                  _context7.next = 14;
                  break;
                }

                throw new _TagNotFound["default"]();

              case 14:
                throw _context7.t0;

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 9]]);
      }));

      function getTagById(_x14, _x15) {
        return _getTagById.apply(this, arguments);
      }

      return getTagById;
    }()
  }, {
    key: "createOrUpdateTag",
    value: function () {
      var _createOrUpdateTag = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(accessToken, resourceUri, tagKey, tagValue) {
        var _this3 = this;

        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.__getTagsPartial(accessToken, {
                  resourceUri: resourceUri,
                  key: tagKey
                }).then(function (res) {
                  var results = res.results;

                  _this3.__debug('createOrUpdateTag for ', resourceUri, tagKey, 'found:', results);

                  if (results.length === 0) {
                    return _this3.createTag(accessToken, resourceUri, tagKey, tagValue);
                  }

                  if (results.length === 1) {
                    return _this3.updateTag(accessToken, results[0].id, resourceUri, tagKey, tagValue);
                  }

                  throw new _ConflictError["default"]('Multiple tags matching.');
                })["catch"](function (e) {
                  _this3.__error(e);

                  throw e;
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createOrUpdateTag(_x16, _x17, _x18, _x19) {
        return _createOrUpdateTag.apply(this, arguments);
      }

      return createOrUpdateTag;
    }()
  }, {
    key: "createTag",
    value: function () {
      var _createTag = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(accessToken, resourceUri, tagKey, tagValue) {
        var axiosInstance, params, response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                axiosInstance = this.__getAxiosInstance(accessToken);
                params = {
                  key: tagKey,
                  value: tagValue,
                  resourceUri: resourceUri
                };
                _context9.prev = 2;

                this.__debug("Calling POST ".concat(this.baseUrl, "/v0/tags"), params);

                _context9.next = 6;
                return axiosInstance.post("".concat(this.baseUrl, "/v0/tags"), params);

              case 6:
                response = _context9.sent;
                return _context9.abrupt("return", response.data);

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](2);

                this.__error(_context9.t0);

                throw _context9.t0;

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 10]]);
      }));

      function createTag(_x20, _x21, _x22, _x23) {
        return _createTag.apply(this, arguments);
      }

      return createTag;
    }()
  }, {
    key: "updateTag",
    value: function () {
      var _updateTag = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(accessToken, id, resourceUri, tagKey, tagValue) {
        var axiosInstance, params, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                axiosInstance = this.__getAxiosInstance(accessToken);
                params = {
                  key: tagKey,
                  value: tagValue,
                  resourceUri: resourceUri
                };
                _context10.prev = 2;

                this.__debug("Calling PUT ".concat(this.baseUrl, "/v0/tags/").concat(encodeURIComponent(id)), params);

                _context10.next = 6;
                return axiosInstance.put("".concat(this.baseUrl, "/v0/tags/").concat(encodeURIComponent(id)), params);

              case 6:
                response = _context10.sent;
                return _context10.abrupt("return", response.data);

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](2);

                this.__error(_context10.t0);

                throw _context10.t0;

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 10]]);
      }));

      function updateTag(_x24, _x25, _x26, _x27, _x28) {
        return _updateTag.apply(this, arguments);
      }

      return updateTag;
    }()
  }, {
    key: "deleteTag",
    value: function () {
      var _deleteTag = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(accessToken, id) {
        var axiosInstance, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                axiosInstance = this.__getAxiosInstance(accessToken);
                _context11.prev = 1;

                this.__debug("Calling DELETE ".concat(this.baseUrl, "/v0/tags/").concat(encodeURIComponent(id)));

                _context11.next = 5;
                return axiosInstance["delete"]("".concat(this.baseUrl, "/v0/tags/").concat(encodeURIComponent(id)));

              case 5:
                response = _context11.sent;
                return _context11.abrupt("return", response.data);

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](1);

                this.__error(_context11.t0);

                throw _context11.t0;

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 9]]);
      }));

      function deleteTag(_x29, _x30) {
        return _deleteTag.apply(this, arguments);
      }

      return deleteTag;
    }()
  }]);
  return Tagliatelle;
}();

module.exports = Tagliatelle;